import script from "./AdminNames.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminNames.vue?vue&type=script&setup=true&lang=js"

import "./AdminNames.vue?vue&type=style&index=0&id=c06578ae&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c06578ae"]])

export default __exports__